
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basic-elements/webdienst-footer",
      function () {
        return require("private-next-pages/basic-elements/webdienst-footer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basic-elements/webdienst-footer"])
      });
    }
  